export enum LiveStreamModalType {
  UPLOAD_NEW = 0,
  COVER_PHOTO = 1,
  UPLOADED_CONTENT = 2,
  DESCRIPTION = 3,
  TURN_ON_LIVESTREAM = 4,
  WAITING_SCREEN = 5
}
